"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateHolidays = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const gs_com_modal_dialogs_1 = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const gs_1 = require("@ivanlog/gs");
class StateHolidays extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageHolidays, "Holidays", true);
        this._holidays = [];
        this._canManage = false;
        this.page.ctrls.btnAdd.onclick = () => this._tryAdd();
        this.page.ctrls.btnReload.onclick = () => this._reload();
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this._canManage = this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl);
            this._setupAccess();
            const loaded = yield this._reload();
            if (!loaded)
                return gs_1.StateRunResultEnum.Failed;
            return _super.start.call(this);
        });
    }
    _setupAccess() {
        if (!this._canManage) {
            this.page.ctrls.blockAdd.addClass("no-active");
            this.page.ctrls.btnAdd.hide();
            this.page.ctrls.iDate.el.disabled = true;
        }
        else {
            this.page.ctrls.blockAdd.removeClass("no-active");
            this.page.ctrls.btnAdd.show();
            this.page.ctrls.iDate.el.disabled = false;
        }
    }
    _reload() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.lockgui(this.app.api.admin.directory.getHolidays());
            if (!data)
                return false;
            this._holidays = data
                .filter((holiday) => Boolean(holiday === null || holiday === void 0 ? void 0 : holiday.date))
                .map((holiday) => new models_1.Holiday({ date: holiday.date }))
                .sort((a, b) => (a.date > b.date ? 1 : a.date < b.date ? -1 : 0));
            this._renderList();
            return true;
        });
    }
    _renderList() {
        this.page.ctrls.list.html = "";
        if (!this._holidays.length) {
            const empty = gs.w(gs.html.tag("div", { class: "list-empty" }, "No holidays configured"));
            this.page.ctrls.list.append(empty);
            return;
        }
        for (const holiday of this._holidays) {
            const item = new com.ListItem();
            item.ctrls.lId.text = holiday.date;
            item.ctrls.lType.text = "Holiday";
            item.ctrls.pData.text = this._formatReadableDate(holiday.date);
            if (this._canManage) {
                item.onclick = () => this._confirmDelete(holiday.date);
            }
            else {
                item.addClass("no-active");
            }
            this.page.ctrls.list.append(item);
        }
    }
    _formatReadableDate(value) {
        if (!value)
            return "";
        try {
            const date = new Date(value);
            return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString();
        }
        catch (e) {
            return value;
        }
    }
    _tryAdd() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!this._canManage)
                return;
            const raw = (_a = this.page.ctrls.iDate.el.value) === null || _a === void 0 ? void 0 : _a.trim();
            if (!raw) {
                yield new modalCom.DialogOk("Select date for holiday").show();
                return;
            }
            const normalized = this._normalizeDate(raw);
            if (!normalized) {
                yield new modalCom.DialogOk("Invalid date format").show();
                return;
            }
            if (this._holidays.some((holiday) => holiday.date === normalized)) {
                yield new modalCom.DialogOk("This date is already marked as holiday").show();
                return;
            }
            const payload = [...this._holidays, new models_1.Holiday({ date: normalized })].map((holiday) => new models_1.Holiday({ date: holiday.date }));
            const response = yield this.lockgui(this.app.api.admin.directory.setHolidays(payload));
            if (response === undefined || response === null)
                return;
            this.page.ctrls.iDate.el.value = "";
            yield new modalCom.DialogOk("Holiday added").show();
            yield this._reload();
        });
    }
    _normalizeDate(value) {
        if (!value)
            return null;
        const date = new Date(value);
        if (Number.isNaN(date.getTime()))
            return null;
        const year = date.getUTCFullYear();
        const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
        const day = date.getUTCDate().toString().padStart(2, "0");
        return `${year}-${month}-${day}`;
    }
    _confirmDelete(date) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._canManage)
                return;
            const result = yield new modalCom.DialogOkNo(`Remove holiday ${date}?`).show();
            if (result !== gs_com_modal_dialogs_1.ModalDialogResult.Ok)
                return;
            const response = yield this.lockgui(this.app.api.admin.directory.deleteHoliday(date));
            if (response === undefined || response === null)
                return;
            yield new modalCom.DialogOk("Holiday removed").show();
            yield this._reload();
        });
    }
}
exports.StateHolidays = StateHolidays;
StateHolidays.StateName = "holidays";
//# sourceMappingURL=StateHolidays.js.map